exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".alert-secondary {\n  font-size: small;\n  font-style: italic; }\n\n.container-social {\n  display: -ms-flexbox;\n  display: flex;\n  background-color: #e6f7fe;\n  padding: 15px;\n  border-radius: 15px; }\n\n.social-item {\n  display: inline-block;\n  padding-left: 20px;\n  padding-right: 40px;\n  position: relative;\n  border-right: solid 1px grey; }\n\n.social-item .fa-youtube {\n  font-size: 20px;\n  color: white; }\n\n.circle {\n  width: 50px;\n  height: 50px;\n  background-color: #4890e5;\n  border-radius: 50%;\n  -ms-flex-align: center;\n      align-items: center;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center; }\n\n.social-item input {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  right: 20px; }\n\n.fab.fa-youtube {\n  color: red !important; }\n\n.fab.fa-instagram {\n  color: coral !important;\n  font-size: 20px; }\n\n.tiktok {\n  width: 20px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/projects/project-detail/project-detail.component.scss
// module id = ../../../../../src/app/projects/project-detail/project-detail.component.scss
// module chunks = main